unit UHolidayDetailForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, Types, Vcl.Grids,
  WEBLib.Grids, UMainConfig, WEBLib.Buttons, UHolidayModel, UInstanceList;

type
  THolidayDetailForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    pnlStatus: TPanel;
    sgStatus: TStringGrid;
    pnlButton: TPanel;
    btnCancel: TBitBtn;
    pnlData: TPanel;
    sgHistory: TStringGrid;
    pnlDetails: TPanel;
    lblHeadline: TLabel;
    lblApplicationCreated: TLabel;
    lblReason: TLabel;
    lblStatus: TLabel;
    lblApproved: TLabel;
    lblMotivation: TLabel;
    procedure WebFormResize(Sender: TObject);
    procedure btnBackClick(Sender: TObject);
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
    [Async]
    procedure btnCancelClick(Sender: TObject); async;
  private
    { Private-Deklarationen }
    FMainConfig: TMainConfig;
    FHoliday: THolidayModel;
    FInstanceList: TInstanceList;
    procedure AfterCancelAppForLeave(Sender: TObject);
    procedure GetInstances;
    procedure GetLastFakStamp;
    procedure GetStatus;
    procedure sgHistoryInit;
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetHoliday(const Value: THolidayModel);
    procedure SetInstanceList(const Value: TInstanceList);
  public
    { Public-Deklarationen }
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property Holiday: THolidayModel read FHoliday write SetHoliday;
    property InstanceList: TInstanceList read FInstanceList
      write SetInstanceList;
  protected procedure LoadDFMValues; override; end;

var
  HolidayDetailForm: THolidayDetailForm;

implementation

uses
  UEssentialHelper, UStampModel, UHolidayCancelForm;

{$R *.dfm}

procedure THolidayDetailForm.AfterCancelAppForLeave(Sender: TObject);
begin
  if Self.Holiday.Ergebnis <> '' then
    MessageDLG(Self.Holiday.Ergebnis, mtWarning, [mbOK]);
  Self.btnBackClick(Self);
end;

procedure THolidayDetailForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.Close;
end;

procedure THolidayDetailForm.btnCancelClick(Sender: TObject);
var
  frm: THolidayCancelForm;
begin
  Self.MainConfig.TimerReset;
  frm := THolidayCancelForm.Create(Self);
  frm.Caption := Self.Caption;
  frm.Popup := true;
  await(THolidayCancelForm, frm.Load);
  frm.MainConfig := Self.MainConfig;
  frm.Holiday := Self.Holiday;
  try
    if await(TModalResult, frm.Execute) = mrOK then
    begin
      Self.Holiday.OnPropertyChanged := AfterCancelAppForLeave;
      Self.Holiday.CancelAppForLeave(Self.MainConfig.Uri);
    end;
  finally
    frm.Free;
  end;
end;

procedure THolidayDetailForm.GetInstances;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TInstanceList then
      Self.InstanceList := Sender as TInstanceList;
    Self.sgHistoryInit;
  end;

begin
  if Self.InstanceList = nil then
    Self.InstanceList := TInstanceList.Create;
  Self.InstanceList.OnPropertyChanged := Callback;
  Self.InstanceList.GetAll(Self.MainConfig.Uri, Self.Holiday.Id);
end;

procedure THolidayDetailForm.GetLastFakStamp;
var
  stamp: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      sgStatus.Cells[1, 1] := 'Auftrag: ' + (Sender as TStampModel).Fak.Nr + ' '
        + (Sender as TStampModel).Fak.Bezeichnung;
      sgStatus.Cells[2, 1] := 'Tätigkeit: ' + (Sender as TStampModel)
        .Taet.Bezeichnung;
      sgStatus.Cells[3, 1] := (Sender as TStampModel).Fak.ToStringV1;
      if (sgStatus.Cells[3, 1] <> '') and
        ((Sender as TStampModel).Taet.Bezeichnung <> '') then
        sgStatus.Cells[3, 1] := sgStatus.Cells[3, 1] + ' | ';
      sgStatus.Cells[3, 1] := sgStatus.Cells[3, 1] + (Sender as TStampModel)
        .Taet.Bezeichnung;
    end
    else
    begin
      sgStatus.Cells[1, 1] := 'Auftrag:';;
      sgStatus.Cells[2, 1] := 'Tätigkeit:';
      sgStatus.Cells[3, 1] := '';
    end;
  end;

begin
  stamp := TStampModel.Create;
  stamp.PersonalNr := Self.MainConfig.User.PersonalNr;
  stamp.OnPropertyChanged := Callback;
  stamp.GetLastFakStamp(Self.MainConfig.Uri);
end;

procedure THolidayDetailForm.GetStatus;
var
  stamp: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      sgStatus.Cells[2, 0] := (Sender as TStampModel).Status;
      sgStatus.Cells[3, 0] := Self.MainConfig.User.ToString + ' | ' +
        (Sender as TStampModel).Status;
    end
    else
    begin
      sgStatus.Cells[2, 0] := 'Status: unbekannt';
      sgStatus.Cells[3, 0] := Self.MainConfig.User.ToString;
    end;
  end;

begin
  stamp := TStampModel.Create;
  stamp.PersonalNr := Self.MainConfig.User.PersonalNr;
  stamp.OnPropertyChanged := Callback;
  stamp.GetLastStamp(Self.MainConfig.Uri);
end;

procedure THolidayDetailForm.SetHoliday(const Value: THolidayModel);
begin
  FHoliday := Value;
  lblHeadline.Caption := 'Details zu Antrag: ' + Self.Holiday.Abw.Bezeichnung +
    ' ' + FormatDateTime('ddd. dd.mm.yyyy', Self.Holiday.Von) + ' - ' +
    FormatDateTime('ddd. dd.mm.yyyy', Self.Holiday.Bis);
  lblReason.Caption := 'Grund der Antragsstellung: ' + Self.Holiday.Grund;
  lblApplicationCreated.Caption := 'Antrag erstallt am ' +
    FormatDateTime('ddd. dd.mm.yyyy hh:nn', Self.Holiday.Angelegt);
  lblStatus.Caption := 'Status: ' + Self.Holiday.StatusText;
  if Self.Holiday.Genehmigt then
    lblApproved.Caption := 'genehmigt: ja von ' + Self.Holiday.GenehmigtVon
  else
    lblApproved.Caption := 'genehmigt: nein';
  lblMotivation.Caption := 'Begründung: ' + Self.Holiday.Begruendung;
  pnlButton.Visible := (Self.Holiday.Status = 0) or (Self.Holiday.Status = 1);
  Self.GetInstances;
end;

procedure THolidayDetailForm.SetInstanceList(const Value: TInstanceList);
begin
  FInstanceList := Value;
end;

procedure THolidayDetailForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.TimerReset;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  sgStatus.Cells[1, 0] := Self.MainConfig.User.ToString;
  sgStatus.Cells[2, 0] := 'Status: unbekannt';
  if Self.MainConfig.CommonConfig.WorkOrderTimes then
  begin
    pnlStatus.Height := 56;
    sgStatus.Cells[1, 1] := 'Auftrag:';
    sgStatus.Cells[2, 1] := 'Tätigkeit:';
    Self.GetLastFakStamp;
  end
  else
    pnlStatus.Height := 28;
  Self.WebFormResize(Self);
  Self.GetStatus;
end;

procedure THolidayDetailForm.sgHistoryInit;
var
  i: Integer;
begin
  sgHistory.ColCount := 4;
  sgHistory.RowCount := Self.InstanceList.Count + 1;
  sgHistory.FixedCols := 0;
  sgHistory.FixedRows := 1;
  sgHistory.Cells[0, 0] := '';
  sgHistory.Cells[1, 0] := Bold('Zeitpunkt');
  sgHistory.Cells[2, 0] := Bold('Author');
  sgHistory.Cells[3, 0] := Bold('Vorgang');
  sgHistory.ColWidths[0] := 5;
  sgHistory.ColWidths[1] := 120;
  sgHistory.ColWidths[2] := 60;
  sgHistory.ColWidths[3] := sgHistory.ClientWidth - sgHistory.ColWidths[0] -
    sgHistory.ColWidths[1] - sgHistory.ColWidths[2] - 24;
  for i := 0 to Self.InstanceList.Count - 1 do
  begin
    sgHistory.Cells[0, i + 1] := '';
    sgHistory.Cells[1, i + 1] := FormatDateTime('ddd. dd.mm.yyyy hh:nn',
      Self.InstanceList.Items[i].ErstelltAm);
    sgHistory.Cells[2, i + 1] := Self.InstanceList.Items[i].ErstelltVon;
    sgHistory.Cells[3, i + 1] := Self.InstanceList.Items[i].Inhalt;
  end;
end;

procedure THolidayDetailForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure THolidayDetailForm.WebFormResize(Sender: TObject);
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Antragdetails';
    btnCancel.Top := 4;
    btnCancel.Left := 4;
    btnCancel.Width := 120;
    btnCancel.Height := 32;
    btnCancel.GlyphSize := 24;
    pnlButton.Height := 40;
    lblHeadline.Top := 4;
    lblReason.Top := 20;
    lblApplicationCreated.Top := 36;
    lblStatus.Top := 52;
    lblApproved.Top := 68;
    lblMotivation.Top := 84;
    pnlDetails.Height := 100;
    sgStatus.ColWidths[1] := 0;
    sgStatus.ColWidths[2] := 0;
    sgStatus.ColWidths[3] := sgStatus.ClientWidth - sgStatus.ColWidths[0];
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Antragdetails';
    btnCancel.Top := 8;
    btnCancel.Left := 8;
    btnCancel.Width := 160;
    btnCancel.Height := 48;
    btnCancel.GlyphSize := 32;
    pnlButton.Height := 64;
    lblHeadline.Top := 8;
    lblReason.Top := 32;
    lblApplicationCreated.Top := 56;
    lblStatus.Top := 80;
    lblApproved.Top := 104;
    lblMotivation.Top := 128;
    pnlDetails.Height := 152;
    sgStatus.ColWidths[1] :=
      (sgStatus.ClientWidth - sgStatus.ColWidths[0]) div 2;
    sgStatus.ColWidths[2] := sgStatus.ClientWidth - sgStatus.ColWidths[0] -
      sgStatus.ColWidths[1];
    sgStatus.ColWidths[3] := 0;
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := 64;
  lblHeader.Width := pnlHeader.ClientWidth - btnBack.Width - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  sgStatus.ColWidths[0] := 5;
  sgHistory.ColWidths[3] := sgHistory.ClientWidth - sgHistory.ColWidths[0] -
    sgHistory.ColWidths[1] - sgHistory.ColWidths[2] - 24;
end;

procedure THolidayDetailForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlStatus := TPanel.Create(Self);
  sgStatus := TStringGrid.Create(Self);
  pnlButton := TPanel.Create(Self);
  btnCancel := TBitBtn.Create(Self);
  pnlData := TPanel.Create(Self);
  sgHistory := TStringGrid.Create(Self);
  pnlDetails := TPanel.Create(Self);
  lblHeadline := TLabel.Create(Self);
  lblApplicationCreated := TLabel.Create(Self);
  lblReason := TLabel.Create(Self);
  lblStatus := TLabel.Create(Self);
  lblApproved := TLabel.Create(Self);
  lblMotivation := TLabel.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlStatus.BeforeLoadDFMValues;
  sgStatus.BeforeLoadDFMValues;
  pnlButton.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  pnlData.BeforeLoadDFMValues;
  sgHistory.BeforeLoadDFMValues;
  pnlDetails.BeforeLoadDFMValues;
  lblHeadline.BeforeLoadDFMValues;
  lblApplicationCreated.BeforeLoadDFMValues;
  lblReason.BeforeLoadDFMValues;
  lblStatus.BeforeLoadDFMValues;
  lblApproved.BeforeLoadDFMValues;
  lblMotivation.BeforeLoadDFMValues;
  try
    Name := 'HolidayDetailForm';
    Width := 640;
    Height := 627;
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnScroll', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormResize');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UHolidayDetailForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Antragdetails';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UHolidayDetailForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 603;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlStatus.SetParentComponent(Self);
    pnlStatus.Name := 'pnlStatus';
    pnlStatus.Left := 0;
    pnlStatus.Top := 64;
    pnlStatus.Width := 640;
    pnlStatus.Height := 28;
    pnlStatus.Align := alTop;
    pnlStatus.Caption := 'pnlStatus';
    pnlStatus.ChildOrder := 2;
    pnlStatus.ShowCaption := False;
    sgStatus.SetParentComponent(pnlStatus);
    sgStatus.Name := 'sgStatus';
    sgStatus.Left := 0;
    sgStatus.Top := 0;
    sgStatus.Width := 640;
    sgStatus.Height := 28;
    sgStatus.Align := alClient;
    sgStatus.ColCount := 4;
    sgStatus.FixedCols := 0;
    sgStatus.RowCount := 2;
    sgStatus.FixedRows := 0;
    sgStatus.Font.Charset := ANSI_CHARSET;
    sgStatus.Font.Color := clNavy;
    sgStatus.Font.Height := -16;
    sgStatus.Font.Name := 'Segoe UI Semibold';
    sgStatus.Font.Style := [fsBold];
    sgStatus.Options := [goRangeSelect,goFixedRowDefAlign];
    sgStatus.ParentFont := False;
    sgStatus.ScrollBars := ssNone;
    sgStatus.TabOrder := 0;
    sgStatus.RangeEdit.Max := 100.000000000000000000;
    sgStatus.RangeEdit.Step := 1.000000000000000000;
    sgStatus.HeightPercent := 100.000000000000000000;
    sgStatus.WidthPercent := 100.000000000000000000;
    pnlButton.SetParentComponent(Self);
    pnlButton.Name := 'pnlButton';
    pnlButton.Left := 0;
    pnlButton.Top := 92;
    pnlButton.Width := 640;
    pnlButton.Height := 64;
    pnlButton.Align := alTop;
    pnlButton.Caption := 'pnlButton';
    pnlButton.ChildOrder := 3;
    pnlButton.ShowCaption := False;
    btnCancel.SetParentComponent(pnlButton);
    btnCancel.Name := 'btnCancel';
    btnCancel.Tag := 1;
    btnCancel.Left := 8;
    btnCancel.Top := 8;
    btnCancel.Width := 160;
    btnCancel.Height := 48;
    btnCancel.Caption := 'Antrag stornieren';
    btnCancel.Color := clNone;
    btnCancel.Glyph.LoadFromFile('UHolidayDetailForm.pnlButton.btnCancel.Glyph.png');
    btnCancel.GlyphSize := 32;
    btnCancel.HeightPercent := 100.000000000000000000;
    btnCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btnCancel, Self, 'OnClick', 'btnCancelClick');
    pnlData.SetParentComponent(Self);
    pnlData.Name := 'pnlData';
    pnlData.Left := 0;
    pnlData.Top := 156;
    pnlData.Width := 640;
    pnlData.Height := 447;
    pnlData.Align := alClient;
    pnlData.Caption := 'pnlData';
    pnlData.ChildOrder := 4;
    pnlData.ShowCaption := False;
    sgHistory.SetParentComponent(pnlData);
    sgHistory.Name := 'sgHistory';
    sgHistory.Left := 0;
    sgHistory.Top := 153;
    sgHistory.Width := 640;
    sgHistory.Height := 294;
    sgHistory.Align := alClient;
    sgHistory.ColCount := 1;
    sgHistory.FixedCols := 0;
    sgHistory.RowCount := 1;
    sgHistory.FixedRows := 0;
    sgHistory.Options := [goFixedHorzLine,goHorzLine,goRangeSelect,goRowSelect,goFixedRowDefAlign];
    sgHistory.TabOrder := 0;
    sgHistory.RangeEdit.Max := 100.000000000000000000;
    sgHistory.RangeEdit.Step := 1.000000000000000000;
    sgHistory.SelectionTextColor := clBlack;
    sgHistory.HeightPercent := 100.000000000000000000;
    sgHistory.WidthPercent := 100.000000000000000000;
    pnlDetails.SetParentComponent(pnlData);
    pnlDetails.Name := 'pnlDetails';
    pnlDetails.Left := 0;
    pnlDetails.Top := 0;
    pnlDetails.Width := 640;
    pnlDetails.Height := 153;
    pnlDetails.Align := alTop;
    pnlDetails.Caption := 'pnlDetails';
    pnlDetails.ChildOrder := 1;
    pnlDetails.ShowCaption := False;
    lblHeadline.SetParentComponent(pnlDetails);
    lblHeadline.Name := 'lblHeadline';
    lblHeadline.Left := 8;
    lblHeadline.Top := 8;
    lblHeadline.Width := 60;
    lblHeadline.Height := 15;
    lblHeadline.Caption := 'lblHeadline';
    lblHeadline.Font.Charset := ANSI_CHARSET;
    lblHeadline.Font.Color := clNavy;
    lblHeadline.Font.Height := -12;
    lblHeadline.Font.Name := 'Segoe UI Semibold';
    lblHeadline.Font.Style := [fsBold];
    lblHeadline.HeightPercent := 100.000000000000000000;
    lblHeadline.ParentFont := False;
    lblHeadline.WidthPercent := 100.000000000000000000;
    lblApplicationCreated.SetParentComponent(pnlDetails);
    lblApplicationCreated.Name := 'lblApplicationCreated';
    lblApplicationCreated.Left := 8;
    lblApplicationCreated.Top := 56;
    lblApplicationCreated.Width := 115;
    lblApplicationCreated.Height := 15;
    lblApplicationCreated.Caption := 'lblApplicationCreated';
    lblApplicationCreated.HeightPercent := 100.000000000000000000;
    lblApplicationCreated.WidthPercent := 100.000000000000000000;
    lblReason.SetParentComponent(pnlDetails);
    lblReason.Name := 'lblReason';
    lblReason.Left := 8;
    lblReason.Top := 32;
    lblReason.Width := 51;
    lblReason.Height := 15;
    lblReason.Caption := 'lblReason';
    lblReason.HeightPercent := 100.000000000000000000;
    lblReason.WidthPercent := 100.000000000000000000;
    lblStatus.SetParentComponent(pnlDetails);
    lblStatus.Name := 'lblStatus';
    lblStatus.Left := 8;
    lblStatus.Top := 80;
    lblStatus.Width := 45;
    lblStatus.Height := 15;
    lblStatus.Caption := 'lblStatus';
    lblStatus.HeightPercent := 100.000000000000000000;
    lblStatus.WidthPercent := 100.000000000000000000;
    lblApproved.SetParentComponent(pnlDetails);
    lblApproved.Name := 'lblApproved';
    lblApproved.Left := 8;
    lblApproved.Top := 104;
    lblApproved.Width := 65;
    lblApproved.Height := 15;
    lblApproved.Caption := 'lblApproved';
    lblApproved.HeightPercent := 100.000000000000000000;
    lblApproved.WidthPercent := 100.000000000000000000;
    lblMotivation.SetParentComponent(pnlDetails);
    lblMotivation.Name := 'lblMotivation';
    lblMotivation.Left := 8;
    lblMotivation.Top := 128;
    lblMotivation.Width := 71;
    lblMotivation.Height := 15;
    lblMotivation.Caption := 'lblMotivation';
    lblMotivation.HeightPercent := 100.000000000000000000;
    lblMotivation.WidthPercent := 100.000000000000000000;
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlStatus.AfterLoadDFMValues;
    sgStatus.AfterLoadDFMValues;
    pnlButton.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
    pnlData.AfterLoadDFMValues;
    sgHistory.AfterLoadDFMValues;
    pnlDetails.AfterLoadDFMValues;
    lblHeadline.AfterLoadDFMValues;
    lblApplicationCreated.AfterLoadDFMValues;
    lblReason.AfterLoadDFMValues;
    lblStatus.AfterLoadDFMValues;
    lblApproved.AfterLoadDFMValues;
    lblMotivation.AfterLoadDFMValues;
  end;
end;

end.
